module.exports = "/wp-content/themes/onnit/script/cart/dist/bfcm2022Bg-acb52e73.jpg";